import type { ArranjoFaturamento, OmieEmpresaChave } from "@/types/finance";
export type AgenciaPorte = 'A' | 'B' | 'C' | 'D' | 'E';

export const AGENCIA_PORTES: AgenciaPorte[] = ['A', 'B', 'C', 'D', 'E'];

export interface Agencia {
  id: string;
  nome: string;
  segmento?: string;
  categorias?: AgenciaPorte[];
  cidade?: string;
  bairro?: string;
  telefone?: string;
  email?: string;
  website?: string;
  observacoes?: string;
  logo_path?: string;
  cor?: string;
  favorita?: boolean;
  cnpj?: string;
  sigla?: string;
  razao_social?: string;
  endereco?: string;
  contato_nome?: string;
  contato_email?: string;
  contato_cargo?: string;
  /** O invite divide cada período em uma nota por mês; padrão das propostas da agência. */
  moeda_padrao?: string | null;
  fatura_por_competencia_mensal?: boolean;
  /** Competência mensal: dia do mês seguinte ao trabalhado em que a nota sai; sugestão para as propostas. */
  dia_emissao_competencia?: number | null;
  /** Competência mensal: dias entre a nota e o pagamento; sugestão para as propostas. */
  prazo_pagamento_competencia_dias?: number | null;
  /** Impostos sobre profissional + plataforma que a proposta mostra à parte; padrão das propostas da agência. */
  impostos_percentual?: number | null;
  faturamento_empresa?: OmieEmpresaChave | null;
  faturamento_arranjo?: ArranjoFaturamento | null;
  created_at?: string;
  updated_at?: string;
}